// extracted by mini-css-extract-plugin
module.exports = {"footer":"ProductionAssets_footer__3y8mi"};